export const VERSION = '6.39.0'; // x-release-please-version
